import { Listing } from '@smg-real-estate/hg-rets-schema';
import { StorageHelper } from '@smg-real-estate/hg-search-libs';

import { HgLocalStorageKey } from '@/models';

import { isListingValidForSwissCaution } from '../functions/helpers';

export const shouldShowRentalCertificateModal = (
  listing: Listing,
  storageHelper: StorageHelper,
): boolean => {
  return (
    isListingValidForSwissCaution(listing) &&
    storageHelper.getLocalStorageExpirableItem(
      HgLocalStorageKey.RENTAL_CERTIFICATE_MODAL_LAST_DISPLAYED,
    ) === null
  );
};
